<template>
  <div
    class="GridColumn"
    :style="{
      'text-align': align,
      'vertical-align': valign,
      'width': `${width}%`
    }">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'grid-column',
  props: {
    width: {
      type: Number,
      default: 50
    },
    align: {
      type: String,
      default: null
    },
    valign: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.GridColumn {
  box-sizing: border-box;
  display: inline-block;
  vertical-align: top;
}
</style>
